<div class="choose-vehicle-con">
    <div *ngIf="vehicleDetails?.vin?.length === 17" class="row">
        <div class="col-md-6">
          <span *ngIf="isEditMode" class="choose-vehicle-header">{{ 'delivery.currentVehicle' | translate}}</span>
            <span *ngIf="!isEditMode" class="choose-vehicle-header">{{ 'delivery.selectedVehicle' | translate}}</span>
        </div>
        <div class="col-md-6" *ngIf="isUVI || isNVI">
          <h5 class="isUsed">{{isUsed | translate}}</h5>
        </div>
    </div>
    <div *ngIf="vehicleDetails?.vin?.length === 17" class="row" style="display:flex">
      <div class="col-md-6">
        <div class="selected-vehicle">
          <div class="yearMakeModel vehicle-label">
            <span>{{vehicleDetails.yearMakeModel}}</span>
          </div>
          <div class="vin vehicle-label">
            <span class="vin-label">
              VIN
            </span>
            <span class="vin-value">
                {{vehicleDetails.vin}}
            </span>
          </div>
          <div *ngIf="vehicleDetails.stockNo" class="vin vehicle-label">
            <span class="vin-label">
              {{'delivery.stockNo' | translate}}
            </span>
            <span class="vin-value">
                {{vehicleDetails.stockNo}}
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6 message">
        <h5 class="nontoyota" *ngIf="isUVI">{{message | translate}}</h5>
        <div *ngIf="!isTestDrive">
        <h5 class="nontoyota" *ngIf="isNVI">{{'opcodeServiceManagement.status' | translate}} : {{statusMessage | translate}}</h5>
        <h5 class="nontoyota" *ngIf="isNVI">{{arrival | translate}} : {{estimatedDealerArrival | translate}}</h5>
        <h5 [ngClass]="vehicleDetails.isSafetyCampaign ? 'isUsed' : 'nontoyota'">{{isCampaign | translate}}</h5>
      </div>
      </div>
    </div>
    <app-splitter *ngIf="showSplitter" class='app-splitter'  [config]="'horizontal 100% 0 -4px 550px'"></app-splitter>
</div>

